import { render } from "./Geofence.vue?vue&type=template&id=e38b8ef4"
import script from "./Geofence.vue?vue&type=script&lang=js"
export * from "./Geofence.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dashcam_front/dashcam_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__